export default __webpack_public_path__ + "static/media/jurstice.86798792.jpg";